import { FormControlLabel, FormHelperText, Radio, RadioGroup, TableCell, TableRow } from "@mui/material";
import { addMonths } from "date-fns";
import { useSelector } from "react-redux";
import { preguntaHabilitantePlanillaAPorDecreto, preguntaHabilitantePlanillaCPorDecreto } from "../../../commons/enums/RgrlEnums";
import FormikDatePicker from "../../../commons/formik/FormikDatePicker";

const PreguntaTableRow = ({ errors, handleChange, pregunta, preguntaIndex, setFieldValue, values, disabled, setModificarEstadoPlanilla, nombreDecreto, onChangeRadio }) => {
  const planillaA = useSelector((state) => state.rgrl.postRgrl.planillaA);
  const planillaC = useSelector((state) => state.rgrl.postRgrl.planillaC);
  const mesesFechaRegulacion = useSelector((state) => state.rgrl.mesesFechaRegulacion.data);
  const errorSecuencia = errors?.itemsFormularioArt?.[preguntaIndex]?.resultado;
  const rowSpan = !!errorSecuencia ? 2 : 1;
  const valueActualPregunta = values?.itemsFormularioArt[preguntaIndex]?.resultado
  const preguntaHabilitantePlanillaA = preguntaHabilitantePlanillaAPorDecreto[nombreDecreto] === values?.itemsFormularioArt[preguntaIndex]?.secuencia;
  const preguntaHabilitantePlanillaC = preguntaHabilitantePlanillaCPorDecreto[nombreDecreto] === values?.itemsFormularioArt[preguntaIndex]?.secuencia;
  return (
    <>
      <TableRow key={preguntaIndex} >
        <TableCell rowSpan={rowSpan}>{pregunta.pregunta}</TableCell>
        <TableCell sx={errorSecuencia ? { paddingBottom: 0 } : {}}>
          <RadioGroup
            name={`itemsFormularioArt.${preguntaIndex}.resultado`}
            value="1"
            onChange={(props) => {
              const newValue = "1";
              const newDate = null;
              if (valueActualPregunta !== "1" &&
                ((
                  preguntaHabilitantePlanillaA) ||
                  (preguntaHabilitantePlanillaC)
                )
              ) {
                if (preguntaHabilitantePlanillaA) {
                  setModificarEstadoPlanilla("A", [preguntaIndex, newValue, newDate], true);
                }
                if (preguntaHabilitantePlanillaC) {
                  setModificarEstadoPlanilla("C", [preguntaIndex, newValue, newDate], true);
                }
              } else {
                onChangeRadio(setFieldValue, preguntaIndex, newValue, newDate);
              }

            }}
          >
            <FormControlLabel
              value="1"
              control={
                <Radio
                  disabled={disabled}
                  checked={
                    values.itemsFormularioArt[preguntaIndex]
                      ?.resultado === "1"
                  }
                />
              }
            />
          </RadioGroup>
        </TableCell>
        <TableCell sx={errorSecuencia ? { paddingBottom: 0 } : {}}>
          <RadioGroup
            name={`itemsFormularioArt.${preguntaIndex}.resultado`}
            value="0"
            onChange={(props) => {
              const newValue = "0";
              const newDate = (mesesFechaRegulacion && mesesFechaRegulacion !== 0)
                ? addMonths(new Date(), mesesFechaRegulacion)
                : null;
              if (valueActualPregunta === "1" && (
                (preguntaHabilitantePlanillaA && planillaA.length > 0) ||
                (preguntaHabilitantePlanillaC && planillaC.length > 0))
              ) {
                if (preguntaHabilitantePlanillaA) {
                  setModificarEstadoPlanilla("A", [preguntaIndex, newValue, newDate], false);
                }
                if (preguntaHabilitantePlanillaC) {
                  setModificarEstadoPlanilla("C", [preguntaIndex, newValue, newDate], false);
                }
              } else {
                onChangeRadio(setFieldValue, preguntaIndex, newValue, newDate);
              }
            }}
          >
            <FormControlLabel
              value="0"
              control={
                <Radio
                  disabled={disabled}
                  checked={
                    values.itemsFormularioArt[preguntaIndex]
                      ?.resultado === "0"
                  }
                />
              }
            />
          </RadioGroup>
        </TableCell>
        <TableCell sx={errorSecuencia ? { paddingBottom: 0 } : {}}>
          <RadioGroup
            name={`itemsFormularioArt.${preguntaIndex}.resultado`}
            onChange={(props) => {
              const newValue = "2";
              const newDate = null;
              if (valueActualPregunta === "1" &&
                (
                  (
                    preguntaHabilitantePlanillaA && planillaA.length > 0) ||
                  (preguntaHabilitantePlanillaC && planillaC.length > 0)
                )
              ) {
                if (preguntaHabilitantePlanillaA) {
                  setModificarEstadoPlanilla("A", [preguntaIndex, newValue, newDate], false);
                }
                if (preguntaHabilitantePlanillaC) {
                  setModificarEstadoPlanilla("C", [preguntaIndex, newValue, newDate], false);
                }
              } else {
                onChangeRadio(setFieldValue, preguntaIndex, newValue, newDate);
              }

            }}
          >
            <FormControlLabel
              value="2"
              control={
                <Radio
                  disabled={disabled}
                  checked={
                    values.itemsFormularioArt[preguntaIndex]
                      ?.resultado === "2"
                  }
                />
              }
            />
          </RadioGroup>
        </TableCell>
        <TableCell rowSpan={rowSpan} style={{ width: "20%" }}>
          <FormikDatePicker
            name={`itemsFormularioArt.${preguntaIndex}.fechaRegulacion`}
            fullWidth
            disablePast
            maxDate={addMonths(new Date(), 11)}
            disabled={
              values.itemsFormularioArt[preguntaIndex]
                ?.resultado !== "0" || disabled
            }
          />
        </TableCell>


      </TableRow >
      {
        !!errorSecuencia && (
          <TableRow>
            <TableCell colSpan={3}>
              <FormHelperText error={errorSecuencia}>
                {errorSecuencia}
              </FormHelperText>
            </TableCell>
          </TableRow>
        )
      }

    </>
  )
}

export default PreguntaTableRow;